import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { classNames } from "primereact/utils";
import { Icon, SearchMenu } from "@/ds";
import { alinharPainelAoBotao } from "../../alinhar-painel/alinhar-painel";
import {
  dicaPapelObrigatorio,
  EQUIPE_ADD_PAPEL_LABEL,
  EQUIPE_PAPEIS_LABEL,
  EQUIPE_PAPEL_BUSCA_LABEL,
  EQUIPE_PAPEL_EMPTY,
  EQUIPE_PAPEL_OBRIGATORIO_TAG,
} from "../equipe-obra.constants";
import styles from "./adicionar-papel.module.scss";
import type { AdicionarPapelProps, AdicionarPapelViewModel } from "./types-adicionar-papel";

/**
 * "Adicionar Papel" (Figma 12227:422499 e menu `_tieredmenu` 9129:353250): botão e menu com busca dos
 * papéis (`SearchMenu` do DS); o papel obrigatório traz a tag "Obrigatório" e a dica do prazo.
 */
export function AdicionarPapelView(props: AdicionarPapelProps & AdicionarPapelViewModel) {
  const { menu, botao, entradas, escolher, itens, temLinhas, disabled } = props;

  return (
    <>
      <Button
        type="button"
        size="small"
        severity="secondary"
        className={`${styles.botao} ${temLinhas ? "" : styles.botaoSeta}`}
        aria-haspopup="menu"
        disabled={disabled}
        onClick={(event) => {
          botao.current = event.currentTarget;
          menu.current?.toggle(event);
        }}
        data-testid="equipe-obra-add-papel"
      >
        {temLinhas ? (
          <>
            <Icon name="plus" />
            {EQUIPE_ADD_PAPEL_LABEL}
          </>
        ) : (
          <>
            {EQUIPE_ADD_PAPEL_LABEL}
            <Icon name="chevron-down" />
          </>
        )}
      </Button>
      <SearchMenu.Root
        ref={menu}
        items={entradas}
        onSelect={escolher}
        panelClassName={styles.painel}
        onShow={() => alinharPainelAoBotao(menu.current?.getElement(), botao.current)}
        testId="equipe-obra-papel-panel"
      >
        <SearchMenu.Search
          aria-label={EQUIPE_PAPEL_BUSCA_LABEL}
          testId="equipe-obra-papel-search"
        />
        <SearchMenu.List label={EQUIPE_PAPEIS_LABEL}>
          {itens.map((papel) => (
            <SearchMenu.Item
              key={papel.id}
              id={papel.id}
              title={papel.prazoRotulo ? dicaPapelObrigatorio(papel.prazoRotulo) : undefined}
              testId={papel.testId}
            >
              <span className={styles.itemNome}>{papel.nome}</span>
              {papel.prazoRotulo ? (
                <Tag
                  severity="warning"
                  className={classNames("p-tag-xs", styles.obrigatorio)}
                  value={EQUIPE_PAPEL_OBRIGATORIO_TAG}
                  data-rotulo={papel.prazoRotulo}
                />
              ) : null}
            </SearchMenu.Item>
          ))}
          <SearchMenu.Empty>{EQUIPE_PAPEL_EMPTY}</SearchMenu.Empty>
        </SearchMenu.List>
      </SearchMenu.Root>
    </>
  );
}
